import {CommonModule} from "@angular/common";
import {MastheadModule as IvyMastheadModule} from '@crs/ivy';
import {HeaderComponent} from "src/app/common/header/headercomponent/header.component";
import {NgModule} from "@angular/core";
import {HttpEventService} from "src/app/services/http/http-event.service";
import {NotificationsService} from "src/app/services/notifications/notifications.service";
import {UserService} from "src/app/services/user.service";
import {NgxTranslateModule} from "../../translate/translate.module";
import {HeaderService} from "../../services/header/header.service";

@NgModule({
	imports: [
		IvyMastheadModule,
		CommonModule,
		NgxTranslateModule
	],
	declarations: [HeaderComponent],
	exports: [HeaderComponent],
	providers: [HttpEventService, NotificationsService, UserService, HeaderService]
})
export class HeaderModule {
}
